var _rect, _g, _g2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 200,
    fill: "#fafafa",
    rx: 20,
    ry: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 100) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-100,0 Q-80,-40 -40,-30 Q0,-20 40,-30 Q80,-40 100,0",
    stroke: "#4285F4",
    strokeWidth: 6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M-100,0 Q-80,-40 -40,-30 Q0,-20 40,-30 Q80,-40 100,0;                                         M-100,0 Q-80,40 -40,30 Q0,20 40,30 Q80,40 100,0;                                         M-100,0 Q-80,-40 -40,-30 Q0,-20 40,-30 Q80,-40 100,0",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-100,0 Q-80,40 -40,30 Q0,20 40,30 Q80,40 100,0",
    stroke: "#34A853",
    strokeWidth: 6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M-100,0 Q-80,40 -40,30 Q0,20 40,30 Q80,40 100,0;                                         M-100,0 Q-80,-40 -40,-30 Q0,-20 40,-30 Q80,-40 100,0;                                         M-100,0 Q-80,40 -40,30 Q0,20 40,30 Q80,40 100,0",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: -80,
    y1: -20,
    x2: -80,
    y2: 20,
    stroke: "#FBBC05",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "-20;20;-20",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "20;-20;20",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: -15,
    x2: -40,
    y2: 15,
    stroke: "#2efb05",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "-15;15;-15",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "15;-15;15",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -10,
    x2: 0,
    y2: 10,
    stroke: "#fc0303",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "-10;10;-10",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "10;-10;10",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: -15,
    x2: 40,
    y2: 15,
    stroke: "#0905fb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "-15;15;-15",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "15;-15;15",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: -20,
    x2: 80,
    y2: 20,
    stroke: "#f98407",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "-20;20;-20",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "20;-20;20",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: -80,
    y: -25,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: -80,
    y: 35,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    x: -40,
    y: -25,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    x: -40,
    y: 35,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -25,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 35,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: -25,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 35,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: -25,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 35,
    fontFamily: "Courier New, monospace",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#DB4437"
  }, "T"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -20,
    cy: 0,
    r: 5,
    fill: "#4285F4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#34A853"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 0,
    r: 5,
    fill: "#FBBC05"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 170,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#333"
  }, "PASS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.5660ec42027b9b5115c9eaa217e71ca4.svg";
export { ForwardRef as ReactComponent };